module.exports = __webpack_public_path__ + "img/1 — kopia.0117a85c.png";